import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer 
      style={{
        background: '#000',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '60px 5%',
      }}
    >
      <div 
        style={{
          maxWidth: '1400px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '40px',
        }}
      >
        {/* Brand */}
        <div>
          <Link 
            to="/" 
            style={{
              fontSize: '28px',
              fontWeight: 800,
              color: 'white',
              textDecoration: 'none',
              letterSpacing: '-0.5px',
            }}
          >
            Naabu<span style={{ color: '#f06a15' }}>.</span>
          </Link>
          <p 
            style={{
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '14px',
              marginTop: '16px',
              lineHeight: 1.6,
            }}
          >
            Your AI Manager that automatically assigns the right specialists to get real work done.
          </p>
        </div>

        {/* Product */}
        <div>
          <h4
            style={{
              color: 'white',
              fontSize: '14px',
              fontWeight: 600,
              marginBottom: '20px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Product
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Link to="/#how-it-works" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s' }}>How it works</Link>
            <Link to="/agents" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s' }}>Agents</Link>
            <Link to="/coming-soon" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none', fontSize: '14px', transition: 'color 0.3s' }}>Pre-register</Link>
          </div>
        </div>

        {/* Legal */}
        <div>
          <h4 
            style={{
              color: 'white',
              fontSize: '14px',
              fontWeight: 600,
              marginBottom: '20px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            Legal
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <a href="#" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</a>
            <a href="#" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</a>
            <a href="#" style={{ color: 'rgba(255, 255, 255, 0.6)', textDecoration: 'none', fontSize: '14px' }}>Cookie Policy</a>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div 
        style={{
          maxWidth: '1400px',
          margin: '60px auto 0',
          paddingTop: '30px',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px',
        }}
      >
        <p style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '14px' }}>
          © 2025 Naabu. All rights reserved.
        </p>
        <div style={{ display: 'flex', gap: '20px' }}>
          <a href="#" style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '14px', textDecoration: 'none' }}>Twitter</a>
          <a href="#" style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '14px', textDecoration: 'none' }}>LinkedIn</a>
          <a href="#" style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '14px', textDecoration: 'none' }}>GitHub</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
